<div id="browse-panel">
	<div *ngIf="!browseObj.currentBrowse" class="browse-panel-group">
		<div *ngFor="let entryPoint of browseObj.entryPoints; let i = index;" class="browse-panel-entry">
			<div class="truncate">
				<a (click)="loadBrowseEntryPoint(i)" class="panel-title truncate pointMe" title="{{entryPoint.label}}">
					<i class="fa fa-folder" aria-hidden="true"></i>{{entryPoint.label}}
				</a>
				<p class="truncate" title="{{entryPoint.description}}">{{entryPoint.description}}</p>
			</div>
		</div>
	</div>
	<div *ngIf="browseObj.currentBrowse" class="browse-panel-nodes-group">
		<div class="browse-pagination" *ngIf="browseObj.currentBrowse.pager.total > browseObj.currentBrowse.pager.pageSize">
			<ngb-pagination 
			    *ngIf="browseObj.currentBrowse && browseObj.pagination" 
				class="pagination pagination-sm"
				[(page)]="browseObj.currentBrowse.pager.page" 
				[pageSize]="browseObj.currentBrowse.pager.pageSize"
				[collectionSize]="browseObj.currentBrowse.pager.total"
				(pageChange)="pageChanged($event)" 
				[maxSize]="3"
				[boundaryLinks]="true" 
				previousText="&#xf053;" nextText="&#xf054;"
				firstText="&#xf053;&#xf053;" lastText="&#xf054;&#xf054;">
			</ngb-pagination>			
		</div>
		<div class="browse-nodes-container">
			<div class="browse-breadcrumbs">
				<a class="browse-all pointMe" (click)="setCurrentNode(-1);">{{LOCALIZATION.browseAll}}</a>
				<i class="fa fa-chevron-right browse-sep"></i>
				<a (click)="clearCurrentNodes(); loadBrowseEntryPoint(browseObj.currentBrowse.entryIndex);"
					class="truncate pointMe" title="{{browseObj.currentBrowse.label}}">{{browseObj.currentBrowse.label}}
				</a>
				<span *ngFor="let node of browseObj.currentBrowse.nodes; let i = index;">
				    <i class="fa fa-chevron-right browse-sep"></i>
				    <a (click)="setCurrentNode(i)" class="pointMe">{{node.plainvalue}}</a>
				</span>
			</div>
			<div class="browse-nodes">
				<div *ngFor="let child of browseObj.currentBrowse.results; let i = index;" class="clearfix">
					<div class="clearfix" *ngIf="i % 3 == 0"></div>
					<div class="browse-node">
						<a (click)="loadBrowseChildNode(child)" class="truncate pointMe">
							<i class="awesome-angular-tree__node_navigator fa fa-caret-right" aria-hidden="true"></i>
						</a>
						<a (click)="searchBrowseChildNode(child); loadBrowseChildNode(child);" class="awesome-angular-tree__node_name truncate pointMe" title="{{child.plainvalue}}">{{child.displayvalue}}</a>
					</div>
				</div>
				<div *ngIf="!browseObj.currentBrowse.results || browseObj.currentBrowse.results.length == 0">
					<!-- <em>Empty</em> -->
				</div>
			</div>
		</div>
	</div>
</div>
